import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {SectionBgAdaptiveView} from '../../ui_canvas_engine/SectionBgViewAdaptive'
import {UIGameManager} from '../UIGameManager'
import {UIGamePopupConfirmationButtons} from './UIGamePopupConfirmationButtons'
import {UIGamePopupInformationView} from './UIGamePopupInformationView'
import {PopupInformation} from '@colonist/game-base-types'

export class UIGamePopupMechanicIntroductionForBeginners extends SectionBgAdaptiveView {
    protected readonly uiGameManager: UIGameManager
    protected confirmationButtons: UIGamePopupConfirmationButtons
    protected cardPopupInformation: UIGamePopupInformationView
    protected readonly popupInformationFormat: PopupInformation

    constructor(uiGameManager: UIGameManager, popupInformationFormat: PopupInformation) {
        super()
        this.uiGameManager = uiGameManager
        this.popupInformationFormat = popupInformationFormat
        this.uiGameManager.canvasController.app.stage.addChild(this)

        this.createPopupView()
        this.setContainerY()
    }

    private setContainerY() {
        const canvas = this.uiGameManager.canvasController
        this.y = canvas.appH - canvas.bottomViewHeight - this.absoluteHeight
    }

    protected createPopupView() {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.popupWidth

        this.cardPopupInformation = new UIGamePopupInformationView(this.uiGameManager, 0, 0, w, this.popupInformationFormat, this)
        this.cardPopupInformation.scaleImage(0.8)

        const isNewMobileAppUI: boolean = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        if(!isNewMobileAppUI) {
            this.drawTextureBgAroundContent(this.uiGameManager.canvasController.margin * 2)
            return
        }

        this.addConfirmationButtons()
    }

    private addConfirmationButtons() {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.popupWidth

        const minPopupViewHeight = 2.25 * canvas.itemSize
        const popupViewHeight = this.cardPopupInformation.height
        const additionalHeight = popupViewHeight < minPopupViewHeight ? minPopupViewHeight - popupViewHeight : 0
        const padding = this.uiGameManager.canvasController.itemSize / 6 + additionalHeight
        this.drawTextureBgAroundContent(0, padding)

        const bottomButtonH = canvas.itemSize
        const bottomButtonY = this.absoluteHeight - bottomButtonH
        const confirmAction = () => this.closeUI()
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, bottomButtonY, w, bottomButtonH, confirmAction, confirmAction, this, false)
        this.confirmationButtons.checkButton.activateOpacity()
    }

    private closeUI() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
        this.destroy()
    }
}
